export default __webpack_public_path__ + "static/media/nofound.8ed1e4e7.svg";